import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "Privacy Policy": "Privacy Policy",
      "Terms of Service": "Terms of Service",
      "Connect Wallet Error Message" : "Please connect your wallet!",
      "Success!" : "Success!",
      "Request canceled" : "Request canceled",
      "Insufficient Balance Error Message" : "Insufficient balance!",
      "Item No Longer Available Error Message" : "This item is no longer available for sale.",
      "User Reject Request Error Message" : "User reject request!",
      "Transfer" : "Transfer",
      "Buy" : "Buy",
      "Preparing Your Wallet" : "Preparing Your Wallet",
      "Prepare Wallet Info Message" : "To enable transactions on our platform, your wallet must be prepared by creating a payment UTXO. This UTXO is utilized to ensure fully decentralized transactions, prioritizing the safety of your Ordinals during transfers. It's important to remember that this UTXO remains in your wallet and will be used for fulfilling Marketplace transactions in the future. Each time you go through this process, it permits you to make a number of concurrent purchases on our platform. If you engage in numerous concurrent transactions, you will need to undertake this process more frequently.",
      "Prepare your wallet" : "Prepare your wallet",
      "Cancel" : "Cancel",
      "Prepare Wallet Wait Message" : "Please wait for the transaction to confirm and finalize your purchase.",
      "Cart" : "Cart",
      "Network Fee" : "Network Fee",
      "You pay" : "You pay",
      "BUY" : "BUY",
      "RETURN" : "RETURN",
      "Details" : "Details",
      "Price" : "Price",
      "Ticker" : "Ticker",
      "Inscription id" : "Inscription Id",
      "Owner" : "Owner",
      "CLOSE" : "CLOSE",
      "Block" : "Block",
      "Stamp Api Maintance Error Message" : "Please wait. Stamp api is under maintanance!",
      "Support Segwit And Legacy Address Error Message" : "Only support segwit and legacy address!",
      "Address Copied Message" : "Address copied to clipboard!",
      "Collection" : "Collection",
      "Cpid" : "Cpid",
      "Utxo" : "Utxo",
      "Can Not Buy Item Error Message" : "You can't buy this item anymore!",
      "Buy Item Wait Message" : "Please wait for buying this item..",
      "Total Fee" : "Total Fee",
      "Decimals" : "Decimals",
      "Amount" : "Amount",
      "Unit Price" : "Unit Price",
      "Chat Header Text" : "Welcome to the BOCM | Bitcoin On-Chain Messenger",
      "Register Name Error Message" : "Please register a name!",
      "Chats" : "Chats",
      "New Chat" : "New Chat",
      "Search by Name" : "Search by Name",
      "Category" : "Category",
      "Action" : "Action",
      "Total" : "Total",
      "Seller" : "Seller",
      "Buyer" : "Buyer",
      "Time" : "Time",
      "Buy Broadcasted" : "Buy Broadcasted",
      "List" : "List",
      "Delist" : "Delist",
      "Page" : "Page",
      "Exceed Maximum Avaiable Balance Error Message" : "Exceed maximum avaiable balance.",
      "Inscribe Success Message" : "Inscribe successfully done. Please wait..",
      "No Transferable Amount" : "There is no transferable amount.",
      "Inscribe Transfer" : "Inscribe Transfer",
      "Available" : "Available",
      "INSCRIBE" : "INSCRIBE",
      "Item Delist Message" : "Item delisted!",
      "Total Fee Limit Error Message" : "Total price must greater thean 0.0001 BTC.",
      "Update Success Message" : "Updated successfully!",
      "Item List Message" : "Item listed!",
      "Amount Exceed Approved Amount Error Message" : "Amount exceed approved amount!",
      "Approve Token Before List Error Message" : "You need to approve the token before listing it!",
      "Insufficient PBTC Token Balance Error Message" : "Insufficient pBTC token balance!",
      "Wrap BTC to pBTC" : "Wrap BTC to pBTC",
      "Total Amount" : "Total Amount",
      "Approved Amount" : "Approved Amount",
      "Listed Amount" : "Listed Amount",
      "Attached Amount" : "Attached Amount",
      "Total Price" : "Total Price",
      "Price Per Unit" : "Price per unit",
      "Listed successful" : "Listed successful",
      "Request handled!" : "Request handled!",
      "Not Request This Prize" : "You can not request this prize!",
      "REDEEM" : "REDEEM",
      "CANCEL" : "CANCEL",
      "Insert Valid Amount Error Message" : "Please insert valid amount!",
      "Balance Is Not Enough Error Message" : "Balance is not enough!",
      "Transaction Broadcasted Successfully Message" : "Transaction broadcasted successfully! Please wait for confirmation.", 
      "Item Listed Success Message" : "Your item(s) have been listed!",
      "Item Updated Success Message" : "Your item(s) have been updated!",
      "Item Delisted Success Message" : "Your item(s) have been delisted!",
      "DETACH" : "DETACH",
      "DELIST" : "DELIST",
      "UPDATE" : "UPDATE",
      "DEATTACH" : "DEATTACH",
      "Copied!" : "Copied",
      "Token Name" : "Token Name",
      "Holders" : "Holders",
      "Progress" : "Progress",
      "Time" : "Time",
      "Supply" : "Supply",
      "Symbol" : "Symbol",
      "Token Id" : "Token Id",
      "Limit" : "Limit",
      "Mint Progress" : "Mint Progress",
      "Descending Time" : "Descending TIme",
      "Ascending Time" : "Ascending time",
      "Element" : "Element",
      "Deployer" : "Deployer",
      "DeploymentId" : "DeploymentId",
      "Name Copied!" : "Name copied!",
      "Address Copied!" : "Address copied!",
      "Address" : "Address",
      "Token" : "Token",
      "Percentage" : "Percentage",
      "MarketCap" : "MarketCap",
      "Id" : "Id",
      "Volume24H" : "Volume24H",
      "Divisibility" : "Divisibility",
      "Transactions" : "Transactions",
      "Premine" : "Premine",
      "Floor Price" : "Floor Price",
      "Collection Name" : "Collection Name",
      "Number" : "Number",
      "Descending Holders" : "Descending Holders",
      "Ascending Holders" : "Ascending Holders",
      "ALL" : "ALL",
      "LIST" : "LIST",
      "SALES" : "SALES",
      "Buy Broadcasted" : "Buy Broadcasted",
      "My Items" : "My Items",
      "Newest" : "Newest",
      "Oldest" : "Oldest",
      "Highest Price" : "Highest Price",
      "Lowest Price" : "Lowest Price",
      "HOT MINTS" : "HOT MINTS",
      "Name" : "Name",
      "MINT" : "MINT",
      "Edit" : "Edit",
      "EDIT" : "EDIT",
      "Trade" : "Trade",
      "CREATOR" : "CREATOR",
      "SUPPLY" : "SUPPLY",
      "DIVISIBLE" : "DIVISIBLE",
      "LOCKED" : "LOCKED",
      "RETURN" : "RETURN",
      "No Available Blocks Error Message" : "No available blocks",
      "Total Mint Progress" : "Total Mint Progress",
      "Phase Mint Price" : "Phase Mint Price",
      "Limit Per Wallet" : "Limit Per Wallet",
      "Select Random" : "Select Random",
      "Minted" : "Minted",
      "No Blocks" : "No blocks",
      "Install UNIVERSE Error Message" : "Please install Universe wallet!",
      "Install Unisat Wallet Error Message" : "Please install unisat wallet!",
      "Install okxwallet Error Message" : "Please install okxwallet!",
      "Address Copied To Clipboard Success Message" : "Address copied to clipboard!",
      "No Names" : "No Names",
      "Connect" : "Connect",
      "Select Wallet" : "Select Wallet",
      "Wallet" : "Wallet",
      "Names" : "Names",
      "Explorer" : "Explorer",
      "My Profile" : "My Profile",
      "Index" : "Index",
      "Inscribe" : "Inscribe",
      "Low" : "Low",
      "Medium" : "Medium",
      "High" : "High",
      "Transferable" : "Transferable",
      "Balance" : "Balance",
      "Normal" : "Normal",
      "Fast" : "Fast",
      "Custom" : "Custom",
      "Not WhiteListed Error Message" : "This is not whitelisted address!",
      "Insert Block Number Error Message" : "Please insert block number",
      "Insert Inscription Address Error Message" : "Please insert inscription address!",
      "Insert Valid Taproot Address Error Message" : "Please insert valid taproot address!",
      "Insert Parent Inscription Id Error Message" : "Please insert parent inscription id!",
      "Amount Exceeded Per Wallet Error Message" : "Amount exceeded allowed amount per wallet.",
      "No Available Token" : "No available token.",
      "Mint" : "Mint",
      "Select Network Fee You Want" : "Select the network fee you want to pay",
      "Total Cost" : "Total Cost",
      "SUBMIT" : "SUBMIT",
      "Send parent inscription here" : "Send parent inscription here",
      "Please send parent inscription!" : "Please send parent inscription!",
      "Mint successful" : "Mint successful",
      "Inscribing Now" : "Inscribing Now",
      "Do Not Close Window Info Message" : "Don´t close this window before the transaction is complete.",
      "Please Insert Valid Ticker Error Message" : "Please insert valid ticker!",
      "Ticker Already Exist Error Message" : "Ticker already exists!",
      "Please Insert Ticker Error Message" : "Please insert ticker!",
      "Insert Parent Ticker Error Message" : "Please insert parent ticker!",
      "Insert Valid Parent Ticker Error Message" : "Please insert valid parent ticker!",
      "Insert Prj Inscription Id Error Message" : "Please insert prj inscription id!",
      "Insert Prv Inscription Id Error Message" : "Please insert prv inscription id!",
      "Insert Max Supply Of Token Error Message" : "Please insert max supply of token!",
      "Insert Element Inscription Id Error Message" : "Please insert element inscription id!",
      "Insert Payment Receiver Address Error Message" : "Please insert payment receiver address!",
      "Insert Mint Cost Error Message" : "Please insert mint cost!",
      "Insert Data Type Error Message" : "Please insert data type!",
      "Insert Limit Per Wallet Error Message" : "Please insert limit per wallet!",
      "Insert Password Error Message" : "Please insert password!",
      "Password Does Not Match Error Message" : "Password does not match!",
      "Insert Valid Element Inscription Id Error Message" : "Please insert valid element inscription id!",
      "Insert Blk Error Message" : "Please insert blk!",
      "Insert Valid Taproot Address Error Message" : "Please insert valid taproot address!",
      "Error Occured Error Message" : "Error occured!",
      "CREATE" : "CREATE",
      "After Inscribe Please Tap Message" : "Requirement: After the Prv Auth Inscription ID is created and confirmed, you must tap it by sending the inscription to yourself.",
      "Parent" : "Parent",
      "DEPLOY" : "DEPLOY",
      "Open" : "Open",
      "Select Block Number" : "Select Block Number",
      "Deploy" : "Deploy",
      "Deployment Successful" : "Deployment successful",
      "DMT PRV AUTH Creation Successful" : "DMT PRV AUTH creation successful",
      "Successfully Minted" : "successfully minted",
      "Inscribing Now" : "Inscribing Now",
      "Once Confirmed Activate Sending It Info Message" : "Once confirmed, activate it by sending the inscription to yourself.",
      "Custom Fee" : "Custom Fee",
      "Search Name" : "Search Name",
      "Inscribe Amount" : "Inscribe Amount",
      "Insert Amount" : "Insert Amount",
      "Insert Price" : "Insert Price",
      "Search By Token Name Or Id" : "Search by Token Name or Id",
      "Search By Ticker" : "Search by ticker",
      "Search By Rune" : "Search by rune",
      "Search Block" : "Search Block",
      "Input Name Or Address" : "Input Name or Address",
      "Receive Inscriptions At This Address" : "Receive inscriptions at this address (Bitcoin taproot address)",
      "Please Insert Mint Count" : "Please insert mint count",
      "Sats In Inscription" : "Sats In Inscription",
      "Service Fee" : "Service Fee",
      "Mint Airdrop NFT" : "Mint Airdrop NFT",
      "Search" : "Search",
      "Inscription Receiver Address" : "Inscription Receiver Address",
      "Parent Inscription Id" : "Parent Inscription Id",
      "Inscription" : "Inscription",
      "ID" : "ID",
      "Parent Ticker" : "Parent Ticker",
      "DMT Prv Auth Inscription ID" : "DMT Prv Auth Inscription ID",
      "Element Inscription ID" : "Element Inscription ID",
      "Payment Receiver Address" : "Payment receiver address",
      "Mint Price In Sats" : "Mint Price (in sats)",
      "Limit Per Wallet" : "Limit per wallet",
      "Admin Password" : "Admin Password",
      "Confirm Admin Password" : "Confirm Admin Password",
      "Password Is Incorrect" : "Password is incorrect!",
      "Successfully Updated" : "Successfully updated!",
      "ADMIN AREA" : "ADMIN AREA",
      "LOGIN" : "LOGIN",
      "Insert Password" : "Insert Password",
      "Insert Old Password" : "Insert Old Password",
      "Insert New Password" : "Insert New Password",
      "Confirm New Password" : "Confirm New Password",
      "Change Password" : "Change Password",
      "Mint Status" : "Mint Status",
      "WL Addresses OFF ALL" : "WL Addresses (OFF=ALL)",
      "Refresh" : "Refresh",
      "SAVE" : "SAVE",
      "Open" : "Open",
      "Completed" : "Completed",
      "Search By Address" : "Search by address",
      "No Mint Tokens" : "No Mint Tokens",
      "Please Insert Valid Tap Ticker" : "Please insert valid tap ticker!",
      "Register" : "Register",
      "Copy" : "Copy",
      "Points" : "Points",
      "Mint Can Not Start Error Message" : "Mint can not start!",
      "Amount Can Not Exceed 1000 Error Message" : "Amount can not exceed 1000!",
      "Amount Can Not Exceed Maximum Amount Error Message" : "Amount can not maximum amount!",
      "TAPZERO Header" : "THE FIRST PRIV AUTH MINT ON TAP",
      "TAPZERO Subheader" : "$TAPZERO HOLDERS ENJOY A LIFETIME OF ZERO FEES!",
      "Reserved" : "Reserved",
      "Available" : "Available",
      "Name Already Exists" : "Name already exists",
      "Register Your Name" : "Register your name",
      "Insert Name Here" : "Insert Name Here",
      "Linked Wallet Address" : "Linked Wallet Address",
      "Latest registrations" : "Latest registrations",
      "Insert Limit Per Mint Error Message" : "Please insert limit per mint!",
      "Insert Mint Quantity Error Message" : "Please insert mint quantity!",
      "Amount Will Exceed The Max Supply Error Message" : "Amount will exceed the max supply!",
      "Amount Will Exceed The Max Wallet Limit Amount Error Message" : "Amount will exceed the wallet limit amount!",
      "Insert Rune Error Message" : "Please insert Rune / Rune Id!",
      "Insert Valid Rune Error Message" : "Please insert valid Rune / Rune Id!",
      "Rune Ticker Input Label" : "Rune Ticker OR Rune ID",
      "MINT RUNES" : "MINT RUNES",
      "Receiver Address" : "Receiver Address",
      "Repeat Mint Amount" : "Repeat Mint Amount",
      "Minting Now" : "Minting Now",
      "ISTAMPS Header" : "Earn 50% monthly marketplace revenue with $iSTAMPS",
      "MARKETPLACE" : "MARKETPLACE",
      "EXPLORER" : "EXPLORER",
      "INDEX" : "INDEX",
      "WALLET" : "WALLET",
      "ISTAMPS Subheader1" : "Passive income for life",
      "ISTAMPS Subheader2" : "Hold a minimum of 10 $iSTAMPS",
      "Select Ticker Error Message" : "Please select ticker!",
      "TAP2BRC20 Header" : "TAP to BRC-20 Bridge Minting Tool",
      "Homepage Header" : "Home for all your Bitcoin assets.",
      "Homepage Subheader" : "The world’s smartest Bitcoin Wallet for Ordinals, Runes, Stamps, Atomicals, Fractal, and more—everything you need, all in one place!",
      "Download" : "Download",
      "Insert Name Error Message" : "Please insert name!",
      "Insert Wallet Address Error Message" : "Please insert wallet address!",
      "Name Already Exists Error Message" : "Name already exists!",
      "Name Registration Successful Message" : "Name registration successful!",
      "Insert Amount Error Message" : "Please insert amount!",
      "Max Supply" : "Max Supply",
      "Limit Per Mint" : "Limit Per Mint",
      "Mint Quantity" : "Mint quantity",
      "PRV AUTH Creation Successful" : "PRV AUTH creation successful",
      "Receive Address" : "Recipient Address",
      "Mint" : "Mint",
      "Unit Sats" : "Unit Sats",
      "Lim Sats": "Lim Sats (Optional)",
      "Insert Valid Unit Sats Error Message" : "Please insert valid Unit_Sats!",
      "Insert Valid Supply Error Message" : "Please insert valid supply!",
      "Insert Valid Limit Error Message" : "Please insert valid limit!",
      "Max Sats" : "Max Sats",
      "TRANSFER" : "TRANSFER",
      "Search By Output" : "Search By Output",
      "SAFE BTC TRANSFER" : "SAFE BTC TRANSFER",
      "Insert Address" : "Insert Address",
      "PAY" : "PAY",
      "MAX" : "MAX",
      "Insert Address Error Message" : "Please insert address!",
      "Insert Transfer Amount" : "Insert Transfer Amount",
      "SEND" : "SEND",
      "Recipient" : "Recipient",
      "Support Taproot Address Error Message" : "Only support taproot address!",
      "Output" : "Output",
      "Split" : "Split",
      "Merge" : "Merge",
      "Select Utxos Error Message" : "Please select utxos first!",
      "ADD" : "ADD",
      "Amount Does Not Match Error Message" : "Amount does not match!",
      "Search By Amount" : "Search By Amount",
      "UNLOCK" : "UNLOCK",
      "UTXO" : "UTXO",
      "Insert Valid Output Error Message" : "Please insert valid output!",
      "Receive Amount" : "Receive Amount",
      "CHAT" : "CHAT",
      "AIRDROP" : "AIRDROP",
      "LAUNCHPAD" : "LAUNCHPAD",
      "Marketplace" : "Marketplace",
      "Tools" : "Tools",
      "Search by name or address" : "Search by name or address",
      "Select Ticker" : "Select Ticker",
      "Search by address" : "Search by address",
      "Stamp Number" : "Stamp Number",
      "Creator" : "Creator",
      "Divisible" : "Divisible",
      "Locked" : "Locked",
      "Transaction" : "Transaction",
      "Percent" : "Percent",
      "Sales" : "Sales",
      "Asset Information" : "Asset Information",
      "Listings" : "Listings",
      "DOMAIN NAME" : "DOMAIN NAME",
      "SRC101 DOMAIN" : "SRC101 DOMAIN",
      "CONFIRM" : "CONFIRM",
      "Type" : "Type",
      "Selected" : "Selected",
      "Insert Domain Error Message" : "Please insert domain name!",
      "Domain Already Minted Error Message" : "Domain already minted!",
      "Top Level Domain" : "Top Level Domain",
      "Hot Domains" : "Hot Domains",
      "Domain Name" : "Domain Name",
      "Digits" : "Digits",
      "Hot Available Domains" : "Hot Available Domains",
      "SRC-101 DOMAIN NAME REGISTRATION" : "SRC-101 DOMAIN NAME REGISTRATION",
      "DOMAIN NAME REGISTRATION" : "DOMAIN NAME REGISTRATION",
      "REGISTER" : "REGISTER",
      "Insert Valid Domain Name Error Message" : "Please insert valid domain name!",
      "Expiration Time" : "Expiration Time",
      "Permanent" : "Permanent",
      "UNIVERSE NAMES" : "UNIVERSE NAMES",
      "Please Wait" : "Please Wait ...",
      "Domain Successfully Registered" : "Your Domain Name has been successfully registered.",
      "Min Amount Label" : "Min Amount (BTC)",
      "Please Wait Message" : "Please wait...",
      "Presale End Error Message" : "Presale ended!",
      "IDO End Error Message" : "IDO ended!",
      "Presale Amount Error Message" : "Amount should greater than 10K sats!",
      "Presale Amount" : "Amount (BTC)",
      "Description" : "Description",
      "Raised" : "Raised",
      "Remaining" : "Remaining",
      "TIME REMAINING" : "TIME REMAINING",
      "PAY WITH BTC" : "PAY WITH BTC",
      "PAY WITH SOL" : "PAY WITH SOL",
      "Do Not Close Window Info Message" : "Do not close this window until the transaction is complete.",
      "Scan the QRCode to pay:" : "Scan the QRCode to pay:",
      "Or pay to the address below:" : "Or pay to the address below:",
      "Transaction Successful" : "Transaction Successful.",
      "Scan QR Code:" : "Scan QR Code:",
      "PAY WITH WALLET" : "PAY WITH WALLET",
      "Install Phantom Wallet Error Message" : "Please install Phantom Wallet!",
      "Install Solflare Wallet Error Message" : "Please install Solflare Wallet!",
      "Install MagicEden Wallet Error Message" : "Please install MagicEden Wallet!",
      "Insert Valid Receiver Address Error Message" : "Please insert a valid Receive Address",
      'CLAIM' : 'CLAIM',
      'Claim Amount' : 'Claim Amount',
      'Total Fee' : 'Total Fee',
      'No Claimable Whitelist Address Error Message' : 'This addres does not hold 𝛑 token.',
      'Already Claimed Error Message' : 'This address has already claimed the token.',
      'CLAIMED' : 'CLAIMED',
      'Continue With Connected Wallet' : 'Continue with connected wallet',
      'Continue Manually With BTC' : 'Continue manually with BTC',
      'Claim' : 'Claim',
      'Claim Complete' : 'Claim Complete',
      'Trade' : 'Trade',
      'Swap' : 'Swap',
      'Trade and Copy Trade' : 'Trade and Copy Trade',
      'Liquidity | DEFI' : 'Liquidity | DEFI',
      'DASHBOARD' : 'DASHBOARD',
      'About Universe' : 'About Universe',
      'Resources' : 'Resources',
      'API Documentation' : 'API Documentation',
      "Telegram Bot" : "Telegram Bot",
      "Leaderboard" : "Leaderboard",
      "See Full Leaderboard" : "See Full Leaderboard",
      "Leaderboard of Elite Traders" : "Leaderboard of Elite Traders",
      "Id or Name" : "Id or Name",
      "Maximum Mint Amount Error Message" : "Maximum mint amount is 2400!",
      "ClockInSystem Maximum Mint Amount Error Message" : "Maximum mint amount is 20!",
      "Insert ID Error Message" : "Please insert ID!",
      "Insert Valid ID Error Message" : "Please insert valid ID!",
      "Imaginary Alkanes Minting" : "Imaginary Alkanes Minting",
      "No Alkanes Balance" : "No Alkanes Balance",
      "Checkout Alkanes balance of any address" : "Checkout Alkanes balance of any address",
      "NAME" : "NAME",
      "You pay" : "You pay",
      "IMAGINARY ALKANES MINTING" : "IMAGINARY ALKANES MINTING",
      "Install Oyl Wallet Error Message" : "Please install Oyl Wallet!",
      "Per Mint": "Per Mint",
      "In-Progress" : "In Progress",
      "Referal Fee": "Referal Fee",
      "Refer Header": "Refer to Earn",
      "Refer Description" : "Invite your friends - Share your unique referral link and start earning",
      "Referrals" : "Referrals",
      "users" : "users",
      "Sats earned" : "Sats earned",
      "Address/Name" : "Address/Name",
      "Users" : "Users",
      "Sats Earned" : "Sats Earned",
      "LEADERBOARD" : "LEADERBOARD",
      "Top Referrers" : "Top Referrers",
      "Referrer Leaderboard" : "Referrer Leaderboard",
      "Select Utxos": "Select Utxos",
      "Merge Success Message": "Merge successful!",
      "Mint Alkanes": "Mint Alkanes",
      "Mint Not Active Error Message": "Mint is not active!",
      "Comming Soon": "Comming Soon",
      "Insert Receive Address Error Message": "Please insert receive address!",
      "Item Fee": "Item Fee",
      "Ticker Not Found Error Message": "Ticker not found!",
      "Supply Not Enough Error Message": "Mint is complete.",
      "Please check transaction here": "Please check transaction here",
      "Feerate should be greate than": "Feerate should be greate than",
      "MARA": "MARA",
      "Mara fail message": "The fee rate you’ve set is currently lower than the MARA network fee. Your transaction will be automatically broadcast once the MARA fee rate drops below your selected threshold. Please wait.",
      "Upload Image(Optional)": "Upload Image(Optional)",
      "Click or drag to replace image" : "Click or drag to replace image",
      "Drop the image here" : "Drop the image here",
      "Drag and drop an image here, or click to select" : "Drag and drop an image here, or click to select",
      "Only JPEG, PNG, GIF and WebP files are accepted" : "Only JPEG, PNG, GIF and WebP files are accepted",
      "File size must be less than 1KB" : "File size must be less than 1KB",
      "Click or drag to replace file" : "Click or drag to replace file(Max 5 files)",
      "Drag and drop a file here, or click to select" : "Drag and drop a file here, or click to select(Max 5 files)",
      "Drop the file here" : "Drop the file here(Max 5 files)",
      "Please Insert File Error Message" : "Please insert file!",
      "Max Mints" : "Max Mints",
      "Selected Files:" : "Selected Files:",
      "Collection Name(Optional)" : "Collection Name(Optional)",
      "Inscribe successful" : "Inscribe successful",
      "Total Amount" : "Total Amount",
      "MARA fee rate is currently" : "MARA fee rate is currently",
      "We recommend" : "We recommend",
      "for faster confirmation. Lower rates may cause delays, adjust accordingly." : "for faster confirmation. Lower rates may cause delays, adjust accordingly.",
      "Please connect your wallet." : "Please connect your wallet.",
      "Total Balance" : "Total Balance",
      "Transferable Balance" : "Transferable Balance",
      "Available Balance" : "Available Balance",
      "Amount should be less or equal to available balance." : "Amount should be less or equal to available balance.",
      "Transfer successful" : "Transfer successful",
      "Please wait for confirmation." : "Please wait for confirmation.",
      "Only support Unisat and Universe wallet.": "Only support Unisat and Universe wallet.",
      "Inscribe Transfer" : "Inscribe Transfer",
      "Utxo Transfer" : "UTXO Transfer",
      "Please select at least one utxo." : "Please select at least one utxo.",
      "Top Tokens" : "Top Tokens",
      "Quantity" : "Quantity",
      "Minimum item is 10000 sats" : "Minimum item is 10000 sats",
      "Total Volume" : "Total Volume",
      "Volume" : "Volume",
      "Market Cap" : "Market Cap",
      "Trades" : "Trades",
      "All Activity" : "All Activity",
      "Activity" : "Activity",
      "Unit Price in sats" : "Unit Price in sats",
      "Sell" : "Sell",
      "You Receive" : "You Receive",
      "You Pay" : "You Pay",
      "Please select at least one item" : "Please select at least one item",
      "Sell at" : "Sell at",
      "Select Items to Buy" : "Select Items to Buy",
      "Successfully broadcasted." : "Successfully broadcasted.",
      "Item already sold! Plesse try again." : "Item already sold! Plesse try again.",
      "Selected item is already removed!" : "Selected item is already removed!",
      'TRADE OP-20' : 'TRADE OP-20',
      "Transfer (Creates UTXO)" : "Transfer (Creates UTXO)",
      "Transfer (Moves UTXO)" : "Transfer (Moves UTXO)",
      "Domain name (e.g. sats.op)" : "Domain name (e.g. sats.op)",
      "Domain already exists" : "Domain already exists",
      "Invalid Name Error Message" : "Please enter a valid domain name format (e.g., jack.op)",
      "You can only add up to 10 domains" : "You can only add up to 10 domains",
      "Select Domain Name" : "Select Domain Name",
      "No domain name found" : "No domain name found",
      "Please select a domain name" : "Please select a domain name",
      "Items" : "Items",
      "My Items" : "My Items",
      "Search By Domain Name" : "Search By Domain Name",
      "Successfully canceled" : "Successfully cancelled",
      "Successfully updated" : "Successfully updated",
      "Successfully listed" : "Successfully listed",
      "Failed to cancel" : "Failed to cancel",
      "Failed to update" : "Failed to update",
      "Failed to list" : "Failed to list",
      "No Domain Names" : "No Domain Names",
      "Sender" : "Sender",
      "Receiver" : "Receiver",
      "CLOCKINSYSTEM MINT" : "ClockInSystem Mint",
      "CLOCKINSYSTEM RESERVE" : "ClockInSystem Reserve",
      "ClockInTime Info" : "Limited to 1 per address every 144 blocks (≈24 hours).",
      "Receiver Address Or Domain Name" : "Receiver Address Or Domain Name",
      "Bytes Exceeded Error Message" : "Your tx contains more than 80 bytes and it will be broadcasted using MARA. Continue?",
      "OYLZERO: ALKANES PASS" : "OYLZERO: ALKANES PASS",
      "$OYLZERO: Mint Alkanes for FREE" : "$OYLZERO: Mint Alkanes for FREE",
      "Protocol Id" : "Protocol Id",
      "Total Supply" : "Total Supply",
      "Decimal" : "Decimal",
      "Unit Mint" : "Unit Mint",
      "Burned" : "Burned",
      "TxId" : "TxId",
      "In Progress" : "In Progress",
      "Mezcal Warning Message" : "Please lock your Mezcal UTXOs to prevent them from being unintentionally burned.",
      "TRADE MEZCAL RUNES" : "TRADE MEZCAL RUNES",
      "Mezcal Utxo Warning Message" : "We have detected that some UTXOs contain multiple Mezcals in one UTXO. If you continue, some Mezcals will be burned. Do you want to continue?",
      "PROCEED" : "PROCEED",
      "Unmintable" : "Unmintable",
      "Split" : "Split",
      "SPLIT" : "SPLIT",
      "Split Amount" : "Split Amount",
      "Split amount must be greater than 1" : "Split amount must be greater than 1",
      "Success Split Message" : "Successfully split. Please wait for confirmation.",
      "Split Count" : "Split Count",
      "Split count must be greater than 1" : "Split count must be greater than 1",
      "Insert valid amount" : "Insert valid amount",
      "Remain Amount" : "Remain Amount",
      "Separate Mezcal from shared UTXO" : "Separate Mezcal from shared UTXO",
      "Split Mezcal into smaller amounts" : "Split Mezcal into smaller amounts",
      "TRADE MEZCAL" : "TRADE MEZCAL",
      "MINT ALKANES" : "MINT ALKANES",
      "30D Mint Volume:" : "30D Mint Volume:",
      "Discount:" : "Discount:",
      "Discount" : "Discount",
      "Clock In Reserve" : "Clock In Reserve",
      "Select Fee Rate You Want" : "Select Fee Rate You Want",
      "Input Boost Fee Rate You Want" : "Input Boost Fee Rate You Want",
      "Boost Fee Rate" : "Boost Fee Rate",
      "BOOST" : "BOOST",
      "Reserve History" : "Reserve History",
      "BOOSTED" : "BOOSTED",
      "Please insert receiver address" : "Please insert receiver address.",
      "Please select reserve block number" : "Please select block cycle to automate.",
      "Please select correct fee rate" : "Please select correct fee rate.",
      "Please select correct boost fee rate" : "Please select correct boost fee rate.",
      "Boost fee rate must be greater than normal fee rate" : "Boost fee rate must be greater than normal fee rate.",
      "Already Reserved for this address and block number" : "Already Reserved for this address and block number.",
      "Manual" : "Manual",
      "Automated" : "Automated",
      "Select block cycle to automate" : "Select block cycle to automate",
      "Select fee rate" : "Select fee rate",
      "Boost fee rate (optional)" : "Boost fee rate (optional)",
      "Maximum boost fee rate" : "Maximum boost fee rate",
      "Please input correct boost fee rate" : "Please input correct boost fee rate",
      "Cancel" : "Cancel",
      "Boost" : "Boost",
      "Boost Fee Rate" : "Boost Fee Rate",
      "LAUNCHPAD" : "LAUNCHPAD"
    }
  },
  ch: {
    translation: {
      "Privacy Policy": "隐私政策",
      "Terms of Service": "服务条款",
      "Connect Wallet Error Message": "请连接你的钱包！",
      "Success!": "成功！",
      "Request canceled": "请求已取消",
      "Insufficient Balance Error Message": "余额不足!",
      "Item No Longer Available Error Message": "此商品已不再出售。",
      "User Reject Request Error Message": "用户拒绝了请求！",
      "Transfer": "转移",
      "Buy": "购买",
      "Preparing Your Wallet": "准备钱包",
      "Prepare Wallet Info Message": "要在我们的平台上启用交易，您的钱包必须准备好创建支付 UTXO。此 UTXO 用于确保完全去中心化的交易，优先考虑您的 Ordinals 在转账过程中的安全。重要的是要记住，此 UTXO 保留在您的钱包中，并将用于将来完成市场交易。每次您完成此过程时，它都允许您在我们的平台上进行多次并发购买。如果您进行多次并发交易，则需要更频繁地执行此过程。",
      "Prepare your wallet": "准备钱包",
      "Cancel": "取消",
      "Prepare Wallet Wait Message": "请等待交易确认并完成您的购买。",
      "Cart": "购物车",
      "Network_Fee": "网络费用",
      "You_pay": "您支付",
      "BUY": "购买",
      "RETURN": "返回",
      "Details": "详细信息",
      "Price": "价格",
      "Ticker": "行情",
      "Inscription_id": "铭文 ID",
      "Owner": "所有者",
      "CLOSE": "关闭",
      "Block": "区块",
      "Stamp Api Maintance Error Message": "请稍候。Stamp API 正在维护中！",
      "Support Segwit And Legacy Address Error Message": "仅支持segwit和legacy地址！",
      "Address Copied Message": "地址已复制到剪贴板！",
      "Collection": "收藏",
      "Cpid": "Cpid",
      "Utxo": "Utxo",
      "Can Not Buy Item Error Message": "您无法再购买该商品！",
      "Buy Item Wait Message": "请等待购买该商品..",
      "Total Fee": "总费用",
      "Decimals": "小数",
      "Amount": "金额",
      "Unit Price": "单价",
      "Chat Header Text": "欢迎来到 BOCM | 比特币链上通讯",
      "Register Name Error Message": "请注册一个名字！",
      "Chats": "聊天",
      "New Chat": "新聊天",
      "Search by Name": "按名称搜索",
      "Category": "类别",
      "Action": "操作",
      "Total": "总计",
      "Seller": "卖家",
      "Buyer": "买家",
      "Time": "时间",
      "Buy Broadcasted": "购买广播",
      "List": "列表",
      "Delist": "下架",
      "Page": "页面",
      "Exceed Maximum Avaiable Balance Error Message": "超出最大可用余额。",
      "Inscribe Success Message": "铭刻成功。请稍候..",
      "No Transferable Amount": "没有可转让的金额。",
      "Inscribe Transfer": "登记转让",
      "Available": "可用",
      "INSCRIBE": "登记",
      "Item Delist Message": "商品已下架！",
      "Total Fee Limit Error Message": "总费用必须大于 0.0001 BTC。",
      "Update Success Message": "更新成功！",
      "Item List Message": "商品已列出！",
      "Amount Exceed Approved Amount Error Message": "金额超出批准金额！",
      "Approve Token Before List Error Message": "您需要在列出代币之前批准它！",
      "Insufficient PBTC Token Balance Error Message": "pBTC 代币余额不足！",
      "Wrap BTC to pBTC": "将 BTC 兑换为 pBTC",
      "Total Amount": "总金额",
      "Approved Amount": "批准金额",
      "Listed Amount": "上架金额",
      "Attached Amount": "附加金额",
      "Total Price": "总价",
      "Price Per Unit": "每单位价格",
      "Listed successful": "上架成功",
      "Request handled!": "请求已处理！",
      "Not Request This Prize": "您不能索取该奖品！",
      "REDEEM": "兑换",
      "CANCEL": "取消",
      "Insert Valid Amount Error Message": "请输入有效金额！",
      "Balance Is Not Enough Error Message": "帳餘余额不足！",
      "Transaction Broadcasted Successfully Message": "交易广播成功！请等待确认。",
      "Item Listed Success Message": "您的商品已上架！",
      "Item Updated Success Message": "您的商品已更新！",
      "Item Delisted Success Message": "您的商品已被下架！",
      "DETACH": "分离",
      "DELIST": "下架",
      "UPDATE": "更新",
      "DEATTACH": "分离",
      "Copied!": "已复制！",
      "Token Name": "代币名称",
      "Holders": "持有者",
      "Progress": "进度",
      "Supply": "供应量",
      "Symbol": "符号",
      "Token Id": "代币 ID",
      "Limit": "限制",
      "Mint Progress": "铸造进度",
      "Descending Time": "降序时间",
      "Ascending Time": "升序时间",
      "Element": "元素",
      "Deployer": "部署者",
      "DeploymentId": "部署 ID",
      "Name Copied!": "名称已复制！",
      "Address Copied!": "地址已复制！",
      "Address": "地址",
      "Token": "代币",
      "Percentage": "百分比",
      "MarketCap": "市值",
      "Id": "ID",
      "Volume24H": "24 小时交易量",
      "Divisibility": "可分割性",
      "Transactions": "交易",
      "Premine": "预挖",
      "Floor Price": "底价",
      "Collection Name": "收藏名称",
      "Number": "数量",
      "Descending Holders": "降序持有人",
      "Ascending Holders": "升序持有人",
      "ALL": "全部",
      "LIST": "列表",
      "SALES": "销售",
      "My Items": "我的物品",
      "Newest": "最新",
      "Oldest": "最旧",
      "Highest Price": "最高价格",
      "Lowest Price": "最低价格",
      "HOT_MINTS": "热门铸币",
      "Name": "名称",
      "MINT": "铸币",
      "Edit": "编辑",
      "EDIT": "编辑",
      "Trade": "交易",
      "CREATOR": "创建者",
      "SUPPLY": "供应",
      "DIVISIBLE": "可分割",
      "LOCKED": "锁定",
      "No Available Blocks Error Message": "无可用区块错误消息",
      "Total Mint Progress": "总铸币进度",
      "Phase Mint Price": "阶段铸币价格",
      "Limit Per Wallet": "每个钱包限制",
      "Select Random": "选择随机",
      "Minted": "铸币",
      "No Blocks": "无区块",
      "Install UNIVERSE Error Message": "请安装Universe钱包！",
      "Install Unisat Wallet Error Message": "请安装unisat钱包！",
      "Install okxwallet Error Message": "请安装okxwallet钱包！",
      "Address Copied To Clipboard Success Message": "地址已复制到剪贴板！",
      "No Names": "无名称",
      "Connect": "连接",
      "Select Wallet": "选择钱包",
      "Wallet": "钱包",
      "Names": "名称",
      "Explorer": "浏览器",
      "My Profile": "我的个人资料",
      "Index": "索引",
      "Inscribe": "铭刻",
      "Low": "低",
      "Medium": "中",
      "High": "高",
      "Transferable": "可转让",
      "Balance": "余额",
      "Normal": "正常",
      "Fast": "快速",
      "Custom": "自定义",
      "Not WhiteListed Error Message": "这不是白名单地址！",
      "Insert Block Number Error Message": "请输入区块编号",
      "Insert Inscription Address Error Message": "请输入题词地址！",
      "Insert Valid Taproot Address Error Message": "请插入有效的 taproot 地址！",
      "Insert Parent Inscription Id Error Message": "请插入父母铭文ID！",
      "Amount Exceeded Per Wallet Error Message": "每个钱包的金额超出错误消息",
      "No Available Token": "无可用代币",
      "Mint": "铸造",
      "Select Network Fee You Want": "选择您要支付的网络费用",
      "Total Cost": "总成本",
      "SUBMIT": "提交",
      "Send parent inscription here": "在此处发送父铭文",
      "Please send parent inscription!": "请发送父铭文！",
      "Mint successful": "铸造成功",
      "Inscribing Now": "正在铭刻",
      "Do Not Close Window Info Message": "交易完成之前请勿关闭此窗口。",
      "Please Insert Valid Ticker Error Message": "请插入有效的股票代码！",
      "Ticker Already Exist Error Message": "股票行情已存在！",
      "Please Insert Ticker Error Message": "请插入股票代码！",
      "Insert Parent Ticker Error Message": "请插入父代号！",
      "Insert Prj Inscription Id Error Message": "请插入项目铭文id！",
      "Insert Prv Inscription Id Error Message": "请插入prv铭文id！",
      "Insert Max Supply Of Token Error Message": "请输入代币的最大供应量！",
      "Insert Element Inscription Id Error Message": "请插入元素铭文id！",
      "Insert Payment Receiver Address Error Message": "请输入付款收款人地址！",
      "Insert Mint Cost Error Message": "请输入铸币成本！",
      "Insert Data Type Error Message": "请输入数据类型！",
      "Insert Limit Per Wallet Error Message": "请输入每个钱包的限额！",
      "Insert Password Error Message": "请输入密码！",
      "Password Does Not Match Error Message": "密码不匹配！",
      "Insert Valid Element Inscription Id Error Message": "请插入有效的元素铭文ID！",
      "Insert Blk Error Message": "请插入blk！",
      "Insert Valid Taproot Address Error Message" : "请插入有效的 taproot 地址！",
      "Error Occured Error Message": "出現錯誤！",
      "CREATE": "创建",
      "After Inscribe Please Tap Message": "要求：创建并确认 Prv Auth 铭文 ID 后，您必须通过将铭文发送给自己来点击它。",
      "Parent": "父级",
      "DEPLOY": "部署",
      "Open": "打开",
      "Select Block Number": "选择区块号码",
      "Deploy": "部署",
      "Deployment Successful": "部署成功",
      "DMT PRV AUTH Creation Successful": "DMT PRV AUTH 创建成功",
      "Successfully Minted": "成功铸造",
      "Once Confirmed Activate Sending It Info Message": "一旦确认，通过将铭文发送给自己来激活它。",
      "Custom Fee": "自定义费用",
      "Search Name": "搜索名称",
      "Inscribe Amount": "铭刻金额",
      "Insert Amount": "输入金额",
      "Insert Price": "输入价格",
      "Search By Token Name Or Id": "按代币名称或 ID 搜索",
      "Search By Ticker": "按代码搜索",
      "Search By Rune": "按符文搜索",
      "Search Block": "搜索区块",
      "Input Name Or Address": "输入名称或地址",
      "Receive Inscriptions At This Address": "在此地址接收铭文（比特币主根地址）",
      "Please Insert Mint Count": "请输入铸造数量",
      "Sats In Inscription": "铭文中的 Sats",
      "Service Fee": "服务费",
      "Mint Airdrop NFT": "铸造空投 NFT",
      "Search": "搜索",
      "Inscription Receiver Address": "铭文接收者地址",
      "Parent Inscription Id": "父铭文 ID",
      "Inscription": "铭文",
      "ID": "ID",
      "Parent Ticker": "父代码",
      "DMT Prv Auth Inscription ID": "DMT Prv Auth 铭文 ID",
      "Element Inscription ID": "元素铭文 ID",
      "Payment Receiver Address": "付款接收者地址",
      "Mint Price In Sats": "铸造价格（以 Sats 为单位）",
      "Limit Per Wallet" : "每个钱包限额",
      "Admin Password": "管理员密码",
      "Confirm Admin Password": "确认管理员密码",
      "Password Is Incorrect": "密码不正确",
      "Successfully Updated": "成功更新",
      "ADMIN AREA": "管理区",
      "LOGIN": "登录",
      "Insert Password": "输入密码",
      "Insert Old Password": "输入旧密码",
      "Insert New Password": "输入新密码",
      "Confirm New Password": "确认新密码",
      "Change Password": "更改密码",
      "Mint Status": "铸造状态",
      "WL Addresses OFF ALL": "WL 地址全部关闭",
      "Refresh": "刷新",
      "SAVE": "保存",
      "Completed": "已完成",
      "Search By Address": "按地址搜索",
      "No Mint Tokens": "无铸造代币",
      "Please Insert Valid Tap Ticker": "请插入有效的点击代码！",
      "Register": "注册",
      "Copy": "复制",
      "Points": "积分",
      "Mint Can Not Start Error Message": "Mint无法启动！",
      "Amount Can Not Exceed 1000 Error Message": "數量不能超過1000!",
      "Amount Can Not Exceed Maximum Amount Error Message": "數量未達到最大數量！",
      "TAPZERO Header": "首批 PRIV AUTH MINT 即将面世",
      "TAPZERO Subheader": "$TAPZERO 持有者享受终身零费用！",
      "Reserved": "保留",
      "Available" : "可用的",
      "Name Already Exists": "名称已存在",
      "Register Your Name": "注册您的名称",
      "Insert Name Here": "在此插入名称",
      "Linked Wallet Address": "链接的钱包地址",
      "Latest registrations": "最新注册",
      "Insert Limit Per Mint Error Message": "请输入每枚铸币的限额！",
      "Insert Mint Quantity Error Message": "请输入薄荷数量！",
      "Amount Will Exceed The Max Supply Error Message": "数量将超过最大供应量错误消息!",
      "Amount Will Exceed The Max Wallet Limit Amount Error Message": "金额将超出钱包限制金额！",
      "Insert Rune Error Message": "请插入符文/符文ID！",
      "Insert Valid Rune Error Message": "请插入有效的符文/符文 ID！",
      "Rune Ticker Input Label": "符文标记或符文 ID",
      "MINT RUNES": "薄荷符文",
      "Receiver Address": "接收者地址",
      "Repeat Mint Amount": "重复铸币量",
      "Minting Now": "现在铸币",
      "ISTAMPS Header": "使用 $iSTAMPS 赚取 50% 的月市场收入",
      "MARKETPLACE": "市场",
      "EXPLORER": "探索者",
      "INDEX": "索引",
      "WALLET": "钱包",
      "ISTAMPS Subheader1": "终身被动收入",
      "ISTAMPS Subheader2": "持有至少 10 个 $iSTAMPS",
      "Select Ticker Error Message": "请选择股票！",
      "TAP2BRC20 Header": "TAP 至 BRC-20 桥梁铸造工具",
      "Homepage Header": "您所有比特币资产的所在地。",
      "Homepage Subheader": "世界上最智能的比特币钱包，包含序数、符文、印章、原子、分形等——您需要的一切，一应俱全！",
      "Download": "下载",
      "Insert Name Error Message" : "请输入姓名！",
      "Insert Wallet Address Error Message" : "请输入钱包地址！",
      "Name Already Exists Error Message" : "名称已存在！",
      "Name Registration Successful Message" : "名称註冊成功！",
      "Insert Amount Error Message" : "请输入金額！",
      "Max Supply" : "最大供应量",
      "Limit Per Mint" : "每枚硬币限额",
      "Mint Quantity" : "薄荷数量",
      "PRV AUTH Creation Successful" : "PRV AUTH 创建成功",
      "Receive Address" : "接收地址",
      "Mint" : "薄荷",
      "Unit Sats" : "单位卫星",
      "Lim Sats": "限制 Sats（可选）",
      "Insert Valid Unit Sats Error Message" : "请输入有效的单位信息！",
      "Insert Valid Supply Error Message" : "请插入有效供货！",
      "Insert Valid Limit Error Message" : "请插入有效限制！",
      "Max Sats" : "最大限度 Sats",
      "TRANSFER" : "转移",
      "Search By Output" : "按输出搜索",
      "SAFE BTC TRANSFER" : "安全的比特币转账",
      "Insert Address" : "插入地址",
      "PAY" : "支付",
      "MAX" : "最大限度",
      "Insert Address Error Message" : "请输入地址！",
      "Insert Transfer Amount" : "输入转账金额",
      "SEND" : "发送",
      "Recipient" : "接受者",
      "Support Taproot Address Error Message" : "仅支持taproot地址！",
      "Output" : "输出",
      "Split" : "分裂",
      "Merge" : "合并",
      "Select Utxos Error Message" : "请先选择utxos！",
      "ADD" : "添加",
      "Amount Does Not Match Error Message" : "數量不對應！",
      "Search By Amount" : "按金额搜索",
      "UNLOCK" : "开锁",
      "UTXO" : "UTXO",
      "Insert Valid Output Error Message" : "请插入有效的输出！",
      "Receive Amount" : "收到金额",
      "CHAT" : "聊天",
      "AIRDROP" : "空投",
      "LAUNCHPAD" : "发射台",
      "Marketplace" : "市场",
      "Tools" : "工具",
      "Search by name or address" : "按姓名或地址搜索",
      "Select Ticker" : "选择股票代码",
      "Search by address" : "按地址搜索",
      "Stamp Number" : "邮票编号",
      "Creator" : "创建者",
      "Divisible" : "可分割",
      "Locked" : "已锁定",
      "Transaction" : "交易",
      "Percent" : "百分比",
      "Sales" : "销售量",
      "Asset Information" : "资产信息",
      "Listings" : "房源",
      "DOMAIN NAME" : "域名",
      "SRC101 DOMAIN" : "SRC101 域名",
      "CONFIRM" : "确认",
      "Type" : "类型",
      "Selected" : "已选定",
      "Insert Domain Error Message" : "请输入域名!",
      "Domain Already Minted Error Message" : "域名已铸造！",
      "Top Level Domain" : "顶级域名",
      "Hot Domains" : "热门域名",
      "Domain Name" : "域名",
      "Digits" : "数字",
      "Hot Available Domains" : "热门可用域名",
      "SRC-101 DOMAIN NAME REGISTRATION" : "SRC-101 域名注册",
      "DOMAIN NAME REGISTRATION" : "域名注册",
      "REGISTER" : "登记",
      "Insert Valid Domain Name Error Message" : "请输入有效的域名！",
      "Expiration Time" : "到期时间",
      "Permanent" : "永恒的",
      "UNIVERSE NAMES" : "UNIVERSE 名称",
      "Please Wait" : "请稍等 ...",
      "Domain Successfully Registered" : "您的域名已成功注册。",
      "Min Amount Label" : "最低金额 (BTC)",
      "Please Wait Message" : "请稍等...",
      "IDO End Error Message" : "IDO结束!",
      'CLAIM' : '索取',
      "Presale End Error Message" : "预售结束!",
      "Presale Amount Error Message" : "数量应大于 10K sats!",
      "Presale Amount" : "数量 (BTC)",
      "Description" : "描述",
      "Raised" : "提出",
      "Remaining" : "剩余",
      "TIME REMAINING" : "剩余时间",
      "PAY WITH BTC" : "使用 BTC 支付",
      "PAY WITH SOL" : "使用 SOL 支付",
      "Do Not Close Window Info Message" : "交易完成之前请勿关闭此窗口。",
      "Scan the QRCode to pay:" : "扫描二维码支付：",
      "Or pay to the address below:" : "或支付到以下地址：",
      "Transaction Successful" : "交易成功。",
      "Scan QR Code:" : "扫描二维码：",
      "PAY WITH WALLET" : "使用钱包支付",
      "Install Phantom Wallet Error Message" : "请安装 Phantom Wallet!",
      "Install Solflare Wallet Error Message" : "请安装 Solflare Wallet!",
      "Install MagicEden Wallet Error Message" : "请安装 MagicEden Wallet!",
      "Insert Valid Receiver Address Error Message" : "请插入有效的接收地址！",
      "Claim Amount" : "索取数量",
      "Total Fee" : "总费用",
      'No Claimable Whitelist Address Error Message' : '此地址不持有 𝛑 代币。',
      'Already Claimed Error Message' : '此地址已索取代币。',
      "CLAIMED" : "已索取",
      "Claim Complete" : "索取完成",
      "Claim" : "索取",
      "Continue With Connected Wallet" : "继续使用连接的钱包",
      "Continue Manually With BTC" : "继续手动使用 BTC",
      "Trade" : "交易",
      "Swap" : "交换",
      "Trade and Copy Trade" : "交易和复制交易",
      "Liquidity | DEFI" : "流动性 | DEFI",
      "DASHBOARD" : "儀表板",
      "About Universe" : "关于Universe",
      "Resources" : "资源",
      "API Documentation" : "API 文档",
      "Telegram Bot" : "Telegram 机器人",
      "Leaderboard" : "排行榜",
      "See Full Leaderboard" : "查看完整排行榜",
      "Leaderboard of Elite Traders" : "精英交易员排行榜",
      "Id or Name" : "ID 或名称",
      "HOT MINTS" : "热门铸币",
      "Maximum Mint Amount Error Message" : "最大铸币数量为 2400!",
      "Insert ID Error Message" : "请插入 ID!",
      "Insert Valid ID Error Message" : "请插入有效的 ID!",
      "Imaginary Alkanes Minting" : "虚构的 Alkanes 铸造",
      "No Alkanes Balance" : "无 Alkanes 余额",
      "Checkout Alkanes balance of any address" : "查看任何地址的 Alkanes 余额",
      "NAME" : "名称",
      "You pay" : "您支付",
      "IMAGINARY ALKANES MINTING" : "虚构的 Alkanes 铸造",
      "Install Oyl Wallet Error Message" : "请安装 Oyl Wallet!",
      "Per Mint": "薄荷",
      "In-Progress": "进行中",
      "Referal Fee": "推荐费",
      "Refer Header": "推荐赚取",
      "Refer Description" : "邀请朋友 - 与团队分享您的独特推荐链接",
      "Referrals" : "推荐人",
      "users" : "用户",
      "Sats earned" : "赚取的 Sats",
      "Address/Name" : "地址/名称",
      "Users" : "用户",
      "Sats Earned" : "赚取的 Sats",
      "Leaderboard" : "排行榜",
      "Top Referrers" : "顶级推荐人",
      "Referrer Leaderboard" : "推荐人排行榜",
      "Select Utxos": "选择 Utxos",
      "Merge Success Message": "合并成功！",
      "Mint Alkanes": "铸造 Alkanes",
      "Mint Not Active Error Message": "铸造未激活！",
      "Comming Soon": "即将推出",
      "Insert Receive Address Error Message": "请插入接收地址！",
      "Item Fee": "项目费用",
      "Ticker Not Found Error Message": "股票代码不存在！",
      "Supply Not Enough Error Message": "薄荷已完成。",
      "Please check transaction here": "请在此处检查交易",
      "Feerate should be greater than": "feerate 应该大于",
      "Mara fail message": "你设置的手续费率目前低于 MARA 网络的当前费率。当 MARA 手续费降到你设定的阈值以下时，交易将会自动广播。请耐心等待。",
      "Upload Image(Optional)": "上傳圖片(可選)",
      "Click or drag to replace image" : "點擊或拖動以替換圖片",
      "Drop the image here" : "將圖片放在這裡",
      "Drag and drop an image here, or click to select" : "拖放圖片或點擊選擇",
      "Only JPEG, PNG, GIF and WebP files are accepted" : "只接受 JPEG、PNG、GIF 和 WebP 文件",
      "File size must be less than 1KB" : "文件大小必须小于 1KB",
      "Click or drag to replace file" : "點擊或拖動以替換文件(最多5個文件)",
      "Drag and drop a file here, or click to select" : "拖放文件或點擊選擇(最多5個文件)",
      "Drop the file here" : "將文件放在這裡(最多5個文件)",
      "Please Insert File Error Message" : "請插入文件！",
      "Max Mints" : "最大鑄造",
      "Selected Files:" : "已選擇的文件:",
      "Collection Name(Optional)" : "集合名稱(可選)",
      "Inscribe successful" : "銘刻成功",
      "Total Amount" : "總金額",
      "MARA fee rate is currently" : "MARA 費率目前為",
      "We recommend" : "我們建議",
      "for faster confirmation. Lower rates may cause delays, adjust accordingly." : "更快確認。較低的費率可能會導致延遲，請相應調整。",
      "Please connect your wallet." : "請先連接您的錢包",
      "Total Balance" : "總餘額",
      "Transferable Balance" : "可轉移餘額",
      "Available Balance" : "可用餘額",
      "Amount should be less or equal to available balance." : "金額應小於或等於可用餘額。",
      "Transfer successful" : "轉移成功",
      "Please wait for confirmation." : "請等待確認。",
      "Only support Unisat and Universe wallet." : "只支持 Unisat 和 Universe 錢包。",
      "Inscribe Transfer" : "銘刻轉移",
      "Utxo Transfer" : "UTXO 轉移",
      "Please select at least one utxo." : "請至少選擇一個 UTXO。",
      "Top Tokens" : "Top Tokens",
      "Quantity" : "數量",
      "Minimum item is 10000 sats" : "最小項目是 10000 sats",
      "Total Volume" : "總體積",
      "Volume" : "體積",
      "Market Cap" : "市值",
      "Trades" : "交易",
      "All Activity" : "所有活動",
      "Activity" : "活動",
      "Unit Price in sats" : "單位價格",
      "Sell" : "賣",
      "You Receive" : "您收到",
      "You Pay" : "您支付",
      "Please select at least one item" : "請至少選擇一個項目",
      "Sell at" : "賣出價格",
      "Select Items to Buy" : "選擇要購買的項目",
      "Successfully broadcasted." : "成功廣播。",
      "Item already sold! Plesse try again." : "項目已售出！請再試一次。",
      "Selected item is already removed!" : "選擇的項目已經被移除！",
      "TRADE OP-20" : "贸易 OP-20",
      "Transfer (Creates UTXO)" : "轉移 (創建 UTXO)",
      "Transfer (Moves UTXO)" : "轉移 (移動 UTXO)",
      "Name (eg: sats.op)" : "名稱 (eg: sats.op)",
      "Domain already exists" : "域名已存在",
      "Invalid Name Error Message" : "請輸入有效的域名格式 (e.g., jack.op)",
      "You can only add up to 10 domains" : "您只能添加最多 10 個域名",
      "Select Domain Name" : "選擇域名",
      "No domain name found" : "找不到域名",
      "Please select a domain name" : "請選擇域名",
      "My Items" : "我的項目",
      "Items" : "項目",
      "Search By Domain Name" : "按域名搜索",
      "Successfully canceled" : "成功取消",
      "Successfully updated" : "成功更新",
      "Successfully listed" : "成功列表",
      "Failed to cancel" : "取消失敗",
      "Failed to update" : "更新失敗",
      "Failed to list" : "列表失敗",
      "No Domain Names" : "找不到域名",
      "Buy" : "購買",
      "List" : "列表",
      "Cancel" : "取消",
      "Sender" : "發送者",
      "Receiver" : "接收者",
      "CLOCKINSYSTEM MINT" : "ClockInSystem 鑄造",
      "CLOCKINSYSTEM RESERVE" : "ClockInSystem 保留",
      "ClockInSystem Maximum Mint Amount Error Message" : "最大鑄造數量為 20!",
      "ClockInTime Info" : "每个地址每144个区块（约24小时）限1次。",
      "Receiver Address Or Domain Name" : "接收者地址或域名",
      "Bytes Exceeded Error Message" : "您的交易包含超過 80 個字節，並將使用 MARA 廣播。繼續？",
      "OYLZERO: ALKANES PASS" : "OYLZERO: ALKANES PASS",
      "$OYLZERO: Mint Alkanes for FREE" : "$OYLZERO: 免费获得 Mint Alkanes",
      "Protocol Id" : "協議 ID",
      "Total Supply" : "總供應量",
      "Decimal" : "小數",
      "Unit Mint" : "單位鑄造",
      "Burned" : "燃燒",
      "TxId" : "交易 ID",
      "In Progress" : "進行中",
      "Mezcal Warning Message" : "請鎖定您的 Mezcal UTXOs 以防止它們被意外燃燒。",
      "TRADE MEZCAL RUNES" : "贸易 MEZCAL RUNES",
      "TRADE MEZCAL" : "贸易 MEZCAL",
      "MINT ALKANES" : "铸造 ALKANES",
      "Mezcal Utxo Warning Message" : "我們發現一些 UTXOs 包含多個 Mezcal 在同一個 UTXO 中。如果您繼續，一些 Mezcal 將被燃燒。您想繼續嗎？",
      "PROCEED" : "繼續",
      "Unmintable" : "不可铸造",
      "Split" : "分裂",
      "SPLIT" : "分裂",
      "Split Amount" : "分裂金額",
      "Split amount must be greater than 1" : "分裂金額必須大於 1",
      "Success Split Message" : "成功分裂。請等待確認。",
      "Split Count" : "分裂數量",
      "Split count must be greater than 1" : "分裂數量必須大於 1",
      "Insert valid amount" : "输入有效金额",
      "Remain Amount" : "剩余金额",
      "Separate Mezcal from shared UTXO" : "从共享 UTXO 中分离 Mezcal",
      "Split Mezcal into smaller amounts" : "将 Mezcal 分成更小的金额",
      "30D Mint Volume:" : "30D 铸币量:",
      "Discount:" : "折扣:",
      "Discount" : "折扣",
      "Clock In Reserve" : "Clock In Reserve",
      "Select Fee Rate You Want" : "选择手续费率",
      "Input Boost Fee Rate You Want" : "输入提升手续费率",
      "Boost Fee Rate" : "提升手续费率",
      "BOOST" : "提升",
      "Reserve History" : "保留历史",
      "BOOSTED" : "已提升",
      "Please insert receiver address" : "请插入接收地址.",
      "Please select reserve block number" : "请选择要自动化的区块周期。",
      "Please select correct fee rate" : "请选择正确的手续费率.",
      "Please select correct boost fee rate" : "请选择正确的提升手续费率.",
      "Boost fee rate must be greater than normal fee rate" : "提升手续费率必须大于普通手续费率.",
      "Already Reserved for this address and block number" : "此地址和区块已保留.",
      "Manual" : "手动",
      "Automated" : "自动",
      "Select block cycle to automate" : "选择区块周期",
      "Select fee rate" : "选择手续费率",
      "Boost fee rate (optional)" : "提升手续费率 (可选)",
      "Maximum boost fee rate" : "最大提升手续费率",
      "Please input correct boost fee rate" : "请输入正确的提升手续费率",
      "Cancel" : "取消",
      "Boost" : "提升",
      "Boost Fee Rate" : "提升手续费率",
      "LAUNCHPAD" : "启动板"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("lng") ?? "en", 

    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;